<template>
  <v-footer dark class="py-10 align-end d-sm-flex d-md-none">
    <div class="contacts px-3 pb-9">
      <h2>اتصل بنا</h2>
      <p>اتصل بالدعم 19059</p>
      <!-- <a
        href="https://wa.me/201206555516"
        target="_blank"
        rel="noopener"
        aria-label="whatsapp"
        class="no-tap"
        data-v-cb48dec8=""
      >
       رقم الواتساب
      </a> -->
    </div>
    <v-spacer></v-spacer>
    <div class="social">
      <a href="https://www.facebook.com/fresh.eg/" target="_blank"
        ><v-icon color="white" class="mx-3" medium>mdi-facebook</v-icon></a
      >
      <a href="https://www.instagram.com/fresh.eg/" target="_blank">
        <v-icon color="white" class="mx-3" medium>mdi-instagram</v-icon>
      </a>
      <a
        href="https://www.youtube.com/channel/UCJbcrmW-u4p_OpukDxP-rTA"
        target="_blank"
      >
        <v-icon color="white" class="mx-3" medium>mdi-youtube</v-icon>
      </a>

      <a
        href="https://www.linkedin.com/company/fresh-electric-for-home-appliances/"
        target="_blank"
      >
        <v-icon color="white" class="mx-3" medium>mdi-linkedin</v-icon>
      </a>
    </div>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
a {
  text-decoration: none;
}
.contacts h2 {
  margin-bottom: 15px;
}
.contacts p,
.contacts a {
  font-size: 19px;
  color: white;
  margin: 0 !important;
}
@media (min-width: 450px) {
  .mobile-only {
    background: red;
  }
}
</style>
